import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import {
  fetchParentCategories,
  fetchSubCategories,
  fetchChildCategories,
  fetchBrandMappings,
} from "../../../../Redux/filters/slice";
import { fetchProducts } from "../../../../Redux/ecommersProduct/slice";
import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";
import SubCategorieFilter from "./SubCategorieFilter";
import SubCategorieProducts from "./SubCategorieProducts";
import SideCart from "../../../globalcomponents/SideCart/SideCart";

const SubCategorie = () => {
  const dispatch = useAppDispatch();

  // Hardcoded for now as per requested "supercategory from params"
  // but this page route doesn't have params in App.tsx.
  // I'll assume it defaults to one or handles it via state.
  const superCategory = "Clothing";

  const [filters, setFilters] = useState({
    parentCategory: "Women", // Default for SubCategorie page
    subCategory: "",
    childCategory: "",
    brandId: "",
    minPrice: undefined as number | undefined,
    maxPrice: undefined as number | undefined,
    page: 1,
    limit: 20,
  });

  const { parentCategories, subCategories, childCategories, brandMappings } =
    useAppSelector((state) => state.filters);
  const { products, loading, pagination, error } = useAppSelector(
    (state) => state.eCommerceProducts,
  );

  useEffect(() => {
    dispatch(fetchParentCategories({ superCategory }));
    dispatch(fetchBrandMappings({ superCategory, page: 1, limit: 100 }));
  }, [superCategory, dispatch]);

  useEffect(() => {
    if (filters.parentCategory) {
      dispatch(fetchSubCategories({ parentCategory: filters.parentCategory , showOnFilters:true , showOnWebsite:true }));
    }
  }, [filters.parentCategory, dispatch]);

  useEffect(() => {
    if (filters.subCategory) {
      dispatch(fetchChildCategories({ subCategory: filters.subCategory  ,showOnFilters:true , showOnWebsite:true}));
    }
  }, [filters.subCategory, dispatch]);

  useEffect(() => {
    dispatch(
      fetchProducts({
        superCategory,
        category: filters.parentCategory || undefined,
        subCategory: filters.subCategory || undefined,
        childCategory: filters.childCategory || undefined,
        brandId: filters.brandId || undefined,
        minPrice: filters.minPrice,
        maxPrice: filters.maxPrice,
        page: filters.page,
        limit: filters.limit,
      }),
    );
  }, [superCategory, filters, dispatch]);

  const handleFilterChange = (newFilters: Partial<typeof filters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters, page: 1 }));
  };

  const handlePageChange = (newPage: number) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container">
          <div className="d-flex mt-0">
            <div className="border-end custom-wid-1 h-auto justify-content-center text-start h-auto w-15">
              <div>
                <SubCategorieFilter
                  superCategory={superCategory}
                  parentCategories={parentCategories.data}
                  subCategories={subCategories.data}
                  childCategories={childCategories.data}
                  brandMappings={brandMappings.data}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                />
              </div>
            </div>
            <div className=" container">
              <SubCategorieProducts
                products={products}
                loading={loading.products}
                error={error}
              />
              {pagination.totalPages > 1 && (
                <ul className="pagination pagination-dark d-flex justify-content-center pagination-lg mt-5">
                  <li
                    className={`page-item ${pagination.page === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link p-2"
                      onClick={() => handlePageChange(pagination.page - 1)}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">
                        <i className="material-symbols-rounded">
                          keyboard_double_arrow_left
                        </i>
                      </span>
                    </button>
                  </li>
                  {[...Array(pagination.totalPages)].map((_, i) => (
                    <li
                      key={i}
                      className={`page-item ${pagination.page === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link p-2 px-3"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${pagination.page === pagination.totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link p-2"
                      onClick={() => handlePageChange(pagination.page + 1)}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">
                        <i className="material-symbols-rounded">
                          keyboard_double_arrow_right
                        </i>
                      </span>
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      <SideCart />
    </>
  );
};

export default SubCategorie;
